import { observable, action, reaction } from 'mobx'
import { message } from 'antd'

import { StoreExt } from '@utils/reactExt'
import { routerStore } from './../'
import { initialUserInfo, syncUserInfo } from './syncUserInfo'
import { LOCALSTORAGE_KEYS } from '@constants/index'

export class AuthStore extends StoreExt {
  /**
   * 用户信息
   *
   * @type {IAuthStore.UserInfo}
   * @memberof AuthStore
   */
  @observable
  userInfo: IAuthStore.UserInfo = initialUserInfo

  constructor() {
    super()
    reaction(() => this.userInfo, syncUserInfo)
  }

  @action
  login = async (params: IAuthStore.LoginParams): Promise<any> => {
    try {
      console.log(params)

      const res = await this.api.auth.login(params)
      console.log(res)
      if (res.code === 200) {
        routerStore.replace('/')
      } else {
        message.error('邮箱或密码错误')
      }
    } catch (err) {
      console.error(err)
    }
  }

  @action
  jaLogin = async (params: IAuthStore.LoginParams): Promise<any> => {
    try {
      const res = await this.api.auth.jaLogin(params)
      console.log(res)
      if (res.code === 200) {
        routerStore.replace('/journalAdmin/center')
      } else {
        message.error('邮箱或密码错误')
      }
    } catch (err) {
      console.error(err)
    }
  }

  jaLogout = async () => {
    try {
      const res = await this.api.auth.jaLogout()
      console.log(res)
      if (res.data) {
        routerStore.replace('/jalogin')
      } else {
        message.error('邮箱或密码错误')
      }
    } catch (err) {
      console.error(err)
    }
  }

  register = async (params: IAuthStore.RegisterParams): Promise<any> => {
    try {
      console.log('params111', params)
      const res = await this.api.auth.registerUser(params)
      if (res.code === 200) {
        message.success('注册成功，请登录')
      } else {
        message.error('token已过期，请重新发起注册流程')
      }
      // this.setUserInfo(isPlainObject(res) ? res : {})
      // localStorage.setItem(LOCALSTORAGE_KEYS.USERINFO, JSON.stringify(res))
      routerStore.replace('/login')
    } catch (err) {
      console.error(err)
    }
  }


  checkToken = async (params: IAuthStore.CheckEmailTokenParams): Promise<any> => {
    try {
      console.log('AuthEmailParams', params)
      const res = await this.api.auth.checkToken(params)
      console.log(res)
      if (res.code === 200) {

        return res.data;
      } else {
        message.error('token已过期，请重新发起验证')
      }
      // this.setUserInfo(isPlainObject(res) ? res : {})
      // localStorage.setItem(LOCALSTORAGE_KEYS.USERINFO, JSON.stringify(res))
      // routerStore.replace('/login')
    } catch (err) {
      console.error(err)
    }
  }

  authEmail = async (params: IAuthStore.AuthEmailParams): Promise<any> => {
    try {
      console.log('AuthEmailParams', params)
      const res = await this.api.auth.authEmail(params)
      // this.setUserInfo(isPlainObject(res) ? res : {})
      // localStorage.setItem(LOCALSTORAGE_KEYS.USERINFO, JSON.stringify(res))
      routerStore.replace('/login')
    } catch (err) {
      console.error(err)
    }
  }


  resetPwd = async (params: IAuthStore.RegisterParams): Promise<any> => {
    try {
      console.log('params111', params)
      const res = await this.api.auth.resetPwd(params)
      if (res.code === 200) {
        message.success('重置密码成功！')
      } else {
        message.error('token已过期，请重新发起密码找回流程')
      }
      // this.setUserInfo(isPlainObject(res) ? res : {})
      // localStorage.setItem(LOCALSTORAGE_KEYS.USERINFO, JSON.stringify(res))
      routerStore.replace('/login')
    } catch (err) {
      console.error(err)
    }
  }

  lostPassword = async (params: IAuthStore.AuthEmailParams): Promise<any> => {
    try {
      console.log('lostPasswordParams', params)
      const res = await this.api.auth.lostPassword(params)
      if (res.code === 200) {
        message.success('已发送验证邮件到您的邮箱，请登录邮箱完成下一步！')
        return res.data;
      } else {
        message.error(res.message);
      }
      // this.setUserInfo(isPlainObject(res) ? res : {})
      // localStorage.setItem(LOCALSTORAGE_KEYS.USERINFO, JSON.stringify(res))
      // routerStore.replace('/login')
    } catch (err) {
      console.error(err)
    }
  }


  logout = () => {
    this.setUserInfo({})
    localStorage.removeItem(LOCALSTORAGE_KEYS.USERINFO)
    routerStore.replace('/login')
  }

  /**
   * 初始化用户信息
   *
   * @memberof AuthStore
   */
  @action
  setUserInfo = (userInfo: IAuthStore.UserInfo): IAuthStore.UserInfo => {
    this.userInfo = userInfo
    return userInfo
  }
}

export default new AuthStore()
